module.exports = __webpack_public_path__ + "static/media/banner.d286e030.jpg";